/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/search-question-duocolor.json";

export const IllustrativeIconSearchQuestionDuocolor = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconSearchQuestionDuocolor.displayName = "IllustrativeIconSearchQuestionDuocolor";
